import { Checkbox } from 'antd';
import type { UserType } from '@/pages/POS/types';

interface Props {
  value: UserType;
  onChange: (v: UserType) => void;
  /**
   * Khoá không cho đổi loại khách — dùng khi xem/sửa một khách đã tồn tại.
   * Đổi loại sẽ xoá trắng bộ field định danh của loại cũ
   * (`FIELDS_RESET_ON_USER_TYPE_CHANGE`), tức thu ngân mở form ra xem thông tin
   * mà lỡ tay là mất CCCD/MST của khách. Loại khách thuộc về hồ sơ khách, không
   * phải thứ sửa trên đơn.
   *
   * Khoá chứ KHÔNG ẩn: loại khách vẫn phải đọc được.
   */
  disabled?: boolean;
}

const OPTIONS: { label: string; value: UserType }[] = [
  { label: 'Cá nhân', value: 'personal' as UserType },
  { label: 'Tổ chức', value: 'organization' as UserType },
];

export function CustomerTypeToggle({ value, onChange, disabled = false }: Props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Khách hàng</span>
      {OPTIONS.map((opt) => (
        <Checkbox
          key={opt.value}
          checked={value === opt.value}
          disabled={disabled}
          onChange={() => {
            // Mutually exclusive: only act when selecting the not-yet-selected option.
            if (value !== opt.value) onChange(opt.value);
          }}
        >
          {opt.label}
        </Checkbox>
      ))}
    </div>
  );
}
